export default __webpack_public_path__ + "static/media/apple-icon-120x120.51ad5ed3.png";